import { render, staticRenderFns } from "./CommonTemplate.vue?vue&type=template&id=3e35c096&scoped=true"
import script from "./CommonTemplate.vue?vue&type=script&lang=js"
export * from "./CommonTemplate.vue?vue&type=script&lang=js"
import style0 from "./CommonTemplate.vue?vue&type=style&index=0&id=3e35c096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e35c096",
  null
  
)

export default component.exports